import React, { Suspense, lazy } from 'react';
import Header from '../components/landing-v2/sections/Header';
import Hero from '../components/landing-v2/sections/Hero';
import { landingV2Content } from '../constants/landingV2Content';
import { useLandingAnalytics } from '../components/landing-v2/analytics/useLandingAnalytics';

const OneFeed = lazy(() => import('../components/landing-v2/sections/OneFeed'));
const ScoreBreakdown = lazy(() => import('../components/landing-v2/sections/ScoreBreakdown'));
const HowItWorks = lazy(() => import('../components/landing-v2/sections/HowItWorks'));
const Comparison = lazy(() => import('../components/landing-v2/sections/Comparison'));
const Testimonials = lazy(() => import('../components/landing-v2/sections/Testimonials'));
const FAQ = lazy(() => import('../components/landing-v2/sections/FAQ'));
const FinalCTA = lazy(() => import('../components/landing-v2/sections/FinalCTA'));
const Footer = lazy(() => import('../components/landing-v2/sections/Footer'));

function SectionFallback({ minHeight = 480 }) {
  return <div className="w-full bg-surface-soft" style={{ minHeight }} aria-hidden="true" />;
}

export default function LandingScreenV2({
  content = landingV2Content,
  variant = 'default',
  onboardingHref = '/onboarding',
}) {
  const { onCtaPress, onNavPress } = useLandingAnalytics({ variant });
  const heroCtaTitle = content.hero.cta.title;
  const headerCtaTitle = content.header.cta.title;
  const finalCtaTitle = content.finalCTA.cta.title;
  return (
    <div className="lp-v2-root">
      <Header
        ctaTitle={headerCtaTitle}
        ctaHref={onboardingHref}
        onCtaPress={() => onCtaPress('header', { ctaText: headerCtaTitle })}
        onNavPress={onNavPress}
      />
      <Hero
        content={content.hero}
        ctaHref={onboardingHref}
        onCtaPress={() => onCtaPress('hero', { ctaText: heroCtaTitle })}
      />
      <Suspense fallback={<SectionFallback minHeight={1100} />}>
        <OneFeed />
      </Suspense>
      <Suspense fallback={<SectionFallback minHeight={1100} />}>
        <ScoreBreakdown />
      </Suspense>
      <Suspense fallback={<SectionFallback minHeight={820} />}>
        <HowItWorks />
      </Suspense>
      <Suspense fallback={<SectionFallback minHeight={820} />}>
        <Comparison
          ctaTitle={heroCtaTitle}
          ctaHref={onboardingHref}
          onCtaPress={() => onCtaPress('comparison', { ctaText: heroCtaTitle })}
        />
      </Suspense>
      <Suspense fallback={<SectionFallback minHeight={720} />}>
        <Testimonials />
      </Suspense>
      <Suspense fallback={<SectionFallback minHeight={620} />}>
        <FAQ />
      </Suspense>
      <Suspense fallback={<SectionFallback minHeight={520} />}>
        <FinalCTA
          ctaTitle={finalCtaTitle}
          ctaHref={onboardingHref}
          onCtaPress={() => onCtaPress('final_cta', { ctaText: finalCtaTitle })}
        />
      </Suspense>
      <Suspense fallback={<SectionFallback minHeight={120} />}>
        <Footer />
      </Suspense>
    </div>
  );
}
